import { retrieveObjectMapper } from '../..';

export const transformInvoiceItmes = (invoiceItems = [], billableItems = []) =>
  invoiceItems?.map(invoice => {
    const billableItem = billableItems?.find(
      ({ id }) => id === invoice?.fk_billable_item
    );
    return {
      ...retrieveObjectMapper(invoice, [
        'ID:id',
        'fk_invoice',
        'total_amount',
        'display_total_amount',
        'display_adjusted_amount',
        'tax_amount',
        'quantity',
        'unit_price',
        'for_month',
        'label',
      ]),
      billableItem: {
        ...retrieveObjectMapper(billableItem || {}, [
          'ID:id',
          'label',
          'cda_deductible',
          'display_order',
          'from',
          'taxable',
          'to',
          'type:type_string',
          'unit_price',
        ]),
      },
    };
  });

export const transformReceipts = (receipts = []) =>
  receipts?.map(rpt => ({
    ...retrieveObjectMapper(rpt, [
      'ID:id',
      'receipt_no',
      'amount',
      'amount_received',
      'document_no',
      'credit_amount_used',
      'created_at',
      'paymentType',
      'pdfUrl:pdf_url_key',
      'preSignedUrl',
      'remarks',
      'cancelled_date',
      'cancelation_reason',
      'unlinked_reason',
      'status',
      'type',
    ]),
  })) || [];

export const transformInvoices = ({
  invoices = [],
  invoiceItems = [],
  creditDebitNotes = {},
  receipts = {},
}) => {
  const data = invoices?.map(invoice => {
    const invoiceItem = invoiceItems?.filter(
      ({ fkInvoice }) => fkInvoice === invoice?.id
    );
    const creditDebitNote = creditDebitNotes[invoice?.id] || {};
    const receipt = receipts[invoice?.id] || [];

    return {
      ...retrieveObjectMapper(invoice, [
        'ID:id',
        'fk_child',
        'fk_registration_child',
        'created_at',
        'invoice_date',
        'invoice_no',
        'invoiceType:invoice_type_string',
        'label',
        'outstanding_amount',
        'pdfUrl:pdf_url_key',
        'pre_signed_url',
        'remark',
        'status:status_string',
        'total_amount',
        'total_tax_amount',
        'grand_total',
      ]),
      invoiceItems: {
        data: invoiceItem,
        totalCount: invoiceItem?.length || 0,
      },
      creditNotes: creditDebitNote?.creditNotes || {},
      debitNotes: creditDebitNote?.debitNotes || {},
      receipts: {
        data: transformReceipts(receipt),
        totalCount: receipt?.length || 0,
      },
      invoiceVoidNotes: {
        // we don't really need this field as there is no data in monolith response as well.
        data: [],
        totalCount: 0,
      },
    };
  });
  return data;
};

const transformNotes = (data = {}) =>
  retrieveObjectMapper(data, [
    'ID:id',
    'credit_debit_note_no',
    'created_at',
    'credit_debit_note_date',
    'remarks',
    'total_amount',
    'pdfUrl:pdf_url_key',
    'preSignedUrl:pdf_url_key_presigned_url',
  ]);

/* eslint-disable no-restricted-syntax */
export const transformCreditDebitNotes = (data = {}) => {
  const creditDebitNotes = {};
  for (const key of Object.keys(data)) {
    if (data?.[key]) {
      const creditNotes = data?.[key]?.credit_notes || [];
      const debitNotes = data?.[key]?.debit_notes || [];
      creditDebitNotes[key] = {
        creditNotes: {
          data: creditNotes?.map(creditNote => ({
            ...transformNotes(creditNote),
          })),
          totalCount: creditNotes?.length || 0,
        },
        debitNotes: {
          data: debitNotes?.map(debitNote => ({
            ...transformNotes(debitNote),
          })),
          totalCount: debitNotes?.length || 0,
        },
      };
    }
  }
  return creditDebitNotes;
};

export default { transformInvoiceItmes };
